$(document).ready(function() {
	$(".product-form__input--pill input[type='radio']").each(function () {
	   if ($(this).is(":checked")) {
			var inputId = $(this).attr("id");
			var associatedLabel = $("label[for='" + inputId + "']"); // Find the label with matching for attribute
			var svqLabel = associatedLabel.find(".svqLabel").html().toLowerCase();
		   $("#inventory_quantityLabel").html(svqLabel);
		}
	});
	
    setInterval(function() {
        $(".product-form__input--pill").find("label").each(function() {
            $(this).on("click", function() {
                var svqLabel = $(this).find(".svqLabel").html().toLowerCase();
                setTimeout(function() {
                    $("#inventory_quantityLabel").html(svqLabel);
                }, 1500)
            })
        })
    }, 2000);
})